<template>
  <div>
    <v-autocomplete
      :items="options"
      v-model="innerValue"
      item-text="text"
      item-value="value"
      :clearable="!readonly"
      hide-details
      chips
      :loading="loading"
      @keypress="clearMe"
      @change="changeMe"
      @click:clear="clearTask()"
      :search-input.sync="search"
      v-bind="resetProps"
      :readonly="readonly"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import _ from "lodash";

export default {
  props: {
    returnObject: Boolean,
    value: [String, Number, Object, Array],
    items: Array,
    filterType: [String],
    readonly: Boolean,
  },
  data() {
    return {
      innerValue: this.value,
      search: null,
      loading: false,
      selected: null,
      filteredOptions: [],
    };
  },

  watch: {
    value(n) {
      this.innerValue = n;
    },
    innerValue(value) {
      const watchObj = Array.isArray(value)
        ? this.item.itemOptions.filter((i) => value.includes(i.id))
        : this.item.itemOptions.find((i) => i.id === value)
      this.$emit("watchObject", watchObj);
      this.$emit("input", value);
    },
    filterType(newValue) {
      if (newValue) {
        this.filteredOptions = this.options.filter(
          (item) => item.type === newValue
        );
      }
    },
    options(options) {
      this.filteredOptions = options;
    },
    search: _.debounce(async function (newSearch, oldTerm) {
      if (newSearch === oldTerm) return;
      if (!newSearch || newSearch.length < 1) return;
      if (this.loading) return;
      if (this.selected !== null) return;
      this.loading = true;
      await this.addItemOption({
        PageSize: 1000,
        PageNumber: 1,
        SearchTerm: newSearch,
        OrderBy: "name",
        Ascending: true,
      });
      this.loading = false;
      this.$emit("keyup", newSearch);
    }, 500),
  },

  methods: {
    ...mapActions("task", ["getAll", "addItemOption", "clearTask"]),
    onChange(e) {
      this.$emit("onChange", e);
    },

    clearMe() {
      this.selected = null;
    },

    changeMe(m) {
      this.selected = m;
      this.$emit("change", this.innerValue);
    },
  },

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
    ...mapState({
      item: (state) => state.task,
    }),

    itemOptions() {
      return this.task.itemOptions;
    },

    options() {
      return this.item.itemOptions
        .filter((item) => {
          if (this.filterType) {
            return item.type === this.filterType;
          } else {
            return true;
          }
        })
        .map((item) => {
          return {
            ...item,
            value: item.id,
            text: item.name + ` (${item.code} - ${item.type})`,
          };
        });
    },
  },
};
</script>